import {computed, React, _, Fuse} from '@api'
import {GroupByMenuItem} from '@modules'
import {GroupByStore, VLP_COLLECTION_GROUP, VLP_FOLDER_GROUP, VLP_PLAN_GROUP} from '@stores'
import {action, observable, toJS} from 'mobx'

export class GroupByMenuStore {
  constructor(public groupBy: GroupByStore) {

  }

  get catalog() { return this.groupBy.catalog}
  get vlp() { return this.catalog.vlp}

  @computed get noResults() {
    const {isSearching, searchResults} = this
    return isSearching && _.isEmpty(searchResults)
  }

  @computed get hierarchyGroups() {
    const {catalog: {groupBy: {groupByFields}, seasonSelectorFields}} = this
    return _.uniqBy(
             groupByFields.filter(v => !v.showInSpecGroup
                                     && (v.field === VLP_PLAN_GROUP || v.field === VLP_COLLECTION_GROUP || v.field.startsWith(VLP_FOLDER_GROUP) || seasonSelectorFields.some(f => v.field.startsWith(f.field)))).map(v => ({label: v.label, groupName: v.field})),
             v => v.label)
  }

  @computed get hierarchyOptionMenuItems() {
    const {hierarchyGroups, groupBy: {groupingByName}} = this

    return hierarchyGroups.map((v, i) => {
      return <GroupByMenuItem grouping={groupingByName.get(v.groupName)} key={v.groupName}/>
    })
  }

  @computed get specGroups() {
    const {catalog: {groupBy: {groupByFields, groupingByName}, seasonSelectorFields}, catalog, vlp} = this
    return _.orderBy(
      groupByFields.filter(v => {
        // if (v.section) {
        //   const section = catalog.sectionById[v.section]
        //   if (section?.depth > 0 || (section?.esIndex && section?.esIndex != v.esIndex)) return false
        // }
        return !(v.def?.type === 'Tag' || v.def?.type === 'TagList')
               && (v.showInSpecGroup || (v.group?.spec !== false && v.esIndex && v.renderer !== 'text' && !seasonSelectorFields.some(f => v.field.startsWith(f.field))) || v.group?.spec)
      })
        .map(v => ({label: v.label || v.field, groupName: v.field, grouping: groupingByName.get(v.field)}))
        .filter(g => g.grouping?.fieldDefinition?.showInSpecGroup !== false && (g.grouping?.fieldDefinition?.showInSpecGroup || !vlp.hierarchy.parseHierarchyGroup(g.groupName))
                     /*&& g.grouping.fieldDepth === 1*/ // YFTS-9951
        ),
      g => g.groupName
    )
  }

  @computed get specOptionMenuItems() {
    const {specGroups} = this

    return specGroups.map((v, i) => {
      const {grouping: {sectionConfig}} = v
      return <GroupByMenuItem grouping={v.grouping}
                              key={v.groupName}
                              label={!sectionConfig?.label || sectionConfig?.label === v.label ? v.label : `${v.label} (${sectionConfig?.label})`}
                              //label={v.grouping.associatedWorkspace && v.grouping.associatedWorkspace?._id != workspace?.id  ? `${v.grouping.title} (${v.grouping.associatedWorkspace.itemName})` : undefined }
      />
    })
  }

  // region Search

  @observable searchText: string = ''
  onSearch = (e, value: string) => {
    console.log(`onSearch(${value})`)
    this.searchText = value
  }

  @computed get isSearching() {
    return !_.isEmpty(this.searchText)
  }

  @computed get searchWords() {
    const {searchText} = this
    return searchText ? _.escapeRegExp(searchText).split(' ') : []
  }

  @computed get searchResults(): Set<string> {
    const {searchText, fieldSearcher} = this
    //return new Set<string>(fieldSearcher && searchText !== '' ? fieldSearcher.search(searchText).map(v => v.item.field) : [])
    return new Set<string>(fieldSearcher && searchText !== ''
                           ? _.uniq(
                             _.flatMap(
                             searchText
                               .split(' ')
                               .map(v => fieldSearcher.search(v)
                               )).map(v => v.item.field))
                           : [])
  }

  @computed get fieldSearcher(): Fuse<{ field, label }> {
    const {catalog: {groupBy: {groupByFields}, sectionConfigFor, labelForField}} = this
    return new Fuse<{ field, label }>(
      [
        ...groupByFields.map(f => ({field: f.field, section: sectionConfigFor(f.section)?.label, label: labelForField(f)}))
        // ...availableCardFields.map(f => ({field: f.field, label: catalog.labelForField(f)})),
        // ...(selectedSectionConfig && sectionValues.has(selectedSectionConfig.id)
        //     ? sectionValues.get(selectedSectionConfig.id).map(({key}) => ({field: `${selectedSectionConfig.path}.${selectedSectionConfig.viewOptions.field}.${key}`, label: key}))
        //     : []
        // ).map(v => ({...v}))
      ],
      {
        keys: [/*{name: 'section', weight: 0},*/ {name: 'label', weight: 1}],
        isCaseSensitive: false,
        shouldSort: false,
        includeScore: true,
        threshold: .2,
        ignoreLocation: true,
        findAllMatches: true,
        useExtendedSearch: false
      })
  }

  @observable selectedSection = 'all'

  @observable subtitleButtonActive = false

  @action onToggleSubtitleButton = () => {
    this.subtitleButtonActive = !this.subtitleButtonActive
  }
}


// WEBPACK FOOTER //
// ./src/stores/catalog/groupBy/GroupByMenuStore.tsx